import React, { useState, useEffect } from 'react';
import { Menu, MenuItem, Button, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import styles from '../styles/SystemDropdown.module.scss';
import { useHistory } from 'react-router-dom';
import SubdirectoryArrowRightOutlinedIcon from '@mui/icons-material/SubdirectoryArrowRightOutlined';


interface InstrumentItem {
  c_assetdescription: any;
  c_compid: string;
  assetId: string;
  c_instrumentname?: string;
  name?: string; // Fallback for display
}

interface SystemDropdownProps {
  systemName?: string;
  systemData: InstrumentItem[];
  currentAssetId?: string;
  onInstrumentSelect?: (instrumentId: string) => void;
}

const SystemDropdown: React.FC<SystemDropdownProps> = ({
  systemName = '',
  systemData = [],
  currentAssetId,
  onInstrumentSelect,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const history = useHistory();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleInstrumentClick = (instrument: InstrumentItem) => {
    handleClose();

    if (onInstrumentSelect) {
      onInstrumentSelect(instrument.assetId);
    } else {
      // Navigate to instrument details page by default
      history.push(`/elis/instruments/details/${instrument.assetId}`);
    }
  };

  // Don't show dropdown button if there's no system data
  if (!systemName || systemData.length === 0) {
    return <span className={styles.emptySystem}>--</span>;
  }

  return (
    <div className={styles.systemContainer}>
      <div
        className={styles.systemButton}
        onClick={handleClick}
        aria-controls={open ? 'system-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <img
          src="/assets/system-icon.svg"
          alt=""
          className={styles.systemIcon}
        />
        <span className={styles.systemName}>{systemName}</span>
        <KeyboardArrowDownIcon
          className={`${styles.arrowIcon} ${open ? styles.expanded : ''}`}
        />
      </div>

      <Menu
        id="system-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'system-button',
          sx: { padding: 0 },
        }}
        PaperProps={{
          className: styles.dropMenuSystem,
          sx: {
            maxWidth: '300px',
            borderRadius: '4px',
            boxShadow: '0 3px 8px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        <div className={styles.title}>Instruments in this system:</div>
        <div className={styles.content}>
          {systemData.map((instrument) => (
            <div
              key={instrument.c_compid || instrument.assetId}
              className={`${styles.menuItem} ${currentAssetId === instrument.assetId ? styles.active : ''}`}
              onClick={() => handleInstrumentClick(instrument)}
            >
              <SubdirectoryArrowRightOutlinedIcon
                className={styles.instrumentIcon}
              />
              <div className={styles.label}>
                {instrument.c_instrumentname ||
                  instrument.name ||
                  `${instrument.c_compid} - ${instrument.c_assetdescription}`}  
              </div>
            
            </div>
          ))}
        </div>
      </Menu>
    </div>
  );
};

export default SystemDropdown;
